import { createFileRoute } from '@tanstack/react-router';

import { MonCabinet } from '@/features/reglages/cabinet-panel';

export const Route = createFileRoute('/_app/settings/practice')({
  component: MonCabinet,
});
